module.exports = flarum.core.compat['forum/dianLiang/SettingPage'];